import { BehaviorSubject } from "rxjs";

export interface IPrivacyFootprintServiceState {
    [key: string]: BehaviorSubject<string>;
}

export interface IMarkToUpdateFootprintServiceState {
    [key: string]: boolean;
}

export enum IPrivacyFootPrintIssuesType {
    BREACH = 'breach',
    EXPOSURE = 'exposure',
}

export enum IPrivacyFootprintServiceStatus {
    inUse = 'in_use',
    remediation = 'remediation',
    reviewed = 'reviewed'
}

export const PersonalFootprintMaxCategories = 3;